import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { getQuoteOrderValue, QuoteListRow } from 'src/api/db/apiQuote'
import { QuoteOrderValue } from 'src/shared/components/QuoteOrderValue'
import { paths } from 'src/routes/paths'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { Badge } from 'src/shared/components/ui/badge'
import { Image } from 'src/shared/components/ui/image'
import { cn } from 'src/shared/components/ui/utils'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { formatDate as formatDateUtil } from 'src/shared/utils'
import { getQuoteStatusOption } from 'src/shared/consts/quoteStatus'
import { getQuotePreviewThumbnails } from 'src/shared/utils/quoteItemThumbnail'
import { DASHBOARD_ORDER_ROW_HEIGHT } from '../consts'

export const DashboardOrderRow = ({
  quote,
  listSearch = '',
}: {
  quote: QuoteListRow
  listSearch?: string
}) => {
  const navigate = useNavigate()
  const { locale, t } = useLocalization()

  const { previews, extraCount } = useMemo(
    () => getQuotePreviewThumbnails(quote.quote_item, 2),
    [quote.quote_item]
  )
  const visiblePreviews = previews.filter((preview) => preview.url)

  const orderHref =
    `${paths.myAccount}${paths.requests}/${quote.public_id}` +
    (listSearch.startsWith('?') ? listSearch : listSearch ? `?${listSearch}` : '')
  const orderValue = getQuoteOrderValue(quote)

  return (
    <button
      type="button"
      onClick={() => navigate(orderHref)}
      className="flex w-full items-center gap-3 rounded-lg px-3 text-left transition-colors hover:bg-muted/70"
      style={{ height: DASHBOARD_ORDER_ROW_HEIGHT }}
    >
      {visiblePreviews.length > 0 && (
        <Row className="shrink-0 items-center">
          {visiblePreviews.map(({ key, url }, index) => (
            <div
              key={key}
              className={cn(
                'h-8 w-8 shrink-0 overflow-hidden rounded-lg border border-white bg-muted shadow-soft-sm',
                index > 0 && '-ml-2'
              )}
            >
              <Image src={url!} alt="" className="h-full w-full object-cover" />
            </div>
          ))}
          {extraCount > 0 && (
            <div
              className={cn(
                'flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-white bg-muted text-[0.625rem] font-medium tabular-nums text-muted-foreground shadow-soft-sm',
                visiblePreviews.length > 0 && '-ml-2'
              )}
            >
              +{extraCount}
            </div>
          )}
        </Row>
      )}

      <Column className="min-w-0 flex-1 gap-0.5">
        <span className="truncate text-sm text-foreground">{quote.name}</span>
        <span className="text-xs text-muted-foreground">
          {formatDateUtil(quote.created_at, locale)}
        </span>
      </Column>
      <QuoteOrderValue amount={orderValue} size="sm" />
      <Badge
        size="sm"
        variant={getQuoteStatusOption(quote.status)?.color}
        className="shrink-0"
      >
        {t(
          getQuoteStatusOption(quote.status)?.label ??
            'Draft || Utkast'
        )}
      </Badge>
    </button>
  )
}
